import { render, staticRenderFns } from "./sisAutoLogout.vue?vue&type=template&id=43f63f82"
import script from "./sisAutoLogout.vue?vue&type=script&lang=js"
export * from "./sisAutoLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports